import type { Theme } from '@mui/material/styles';

export default function Accordion(theme: Theme) {
  return {
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          maxHeight: '2.5rem',
          minHeight: '2.5rem',
          fontSize: '0.875rem',
          flexDirection: 'row-reverse',
          background: theme.palette.grey[200],
          fontFamily: "'Montserrat', sans-serif",
          '&.Mui-expanded': {
            minHeight: '2.5rem',
            maxHeight: '2.5rem',
          },
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
          },
        },
      },
    },
  };
}
